export default function trackEvent (event: string, action: string) {
  useNuxtApp().$gtag('event', event, { action })
}